import {
	ApiUtils,
	_axios
} from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/rptAnswers/list", params, successCallback, failCallback, exceptionCallback);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/exams/rptAnswers/save", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/rptAnswers/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/exams/rptAnswers/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/exams/rptAnswers/remove", params, successCallback, failCallback, exceptionCallback);
	},
	selectExm: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/rptAnswers/selectExm", params, successCallback, failCallback, exceptionCallback);
	},
	stat: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/rptAnswers/stat", params, successCallback, failCallback, exceptionCallback);
	},
	selectStuAn: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/rptAnswers/selectStuAn", params, successCallback, failCallback, exceptionCallback);
	}, getRpt1: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/rptAnswers/getRpt1", params, successCallback, failCallback, exceptionCallback);
	}, cntSubScore: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/rptAnswers/cntSubScore", params, successCallback, failCallback, exceptionCallback);
	}, examReport: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/rptAnswers/examReport", params, successCallback, failCallback, exceptionCallback);
	}, getScoreByStuAndQuestion: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/rptAnswers/getScoreByStuAndQuestion", params, successCallback, failCallback, exceptionCallback);
	},  getExamPaperSortInfoByStu: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/rptAnswers/getExamPaperSortInfoByStu", params, successCallback, failCallback, exceptionCallback);
	}
}

export default api;
